import moment from "moment";
import DateBookRepository from "../../Repository/DateBookRepository";
import DefaultRepository from "../../Repository/DefaultRepository";
import PurchaseRepository from "../../Repository/PurchaseRepository";
import SalesRepository from "../../Repository/SalesRepository";
import Repo from "../../Repository/Repo";
import { sendEmailNotification } from "../bills/httpCalls";

export const getWeeklySales = async () => {
  let { data } = await SalesRepository.salesModel({
    request: {
      method: "getWeeklySales",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  });
  let weeks = {
    mon: { total: 0, profit: 0, loss: 0 },
    tue: { total: 0, profit: 0, loss: 0 },
    wed: { total: 0, profit: 0, loss: 0 },
    thur: { total: 0, profit: 0, loss: 0 },
    fri: { total: 0, profit: 0, loss: 0 },
    sat: { total: 0, profit: 0, loss: 0 },
    sun: { total: 0, profit: 0, loss: 0 },
  };
  data.response.data?.dailySales?.forEach((item) => {
    if (item.day == "monday") {
      weeks.mon.total = item?.total;
      weeks.mon.profit = item?.profit;
      weeks.mon.loss = item?.loss;
    } else if (item.day == "tuesday") {
      weeks.tue.total = item?.total;
      weeks.tue.profit = item?.profit;
      weeks.tue.loss = item?.loss;
    } else if (item.day == "wednesday") {
      weeks.wed.total = item?.total;
      weeks.wed.profit = item?.profit;
      weeks.wed.loss = item?.loss;
    } else if (item.day == "thursday") {
      weeks.thur.total = item?.total;
      weeks.thur.profit = item?.profit;
      weeks.thur.loss = item?.loss;
    } else if (item.day == "friday") {
      weeks.fri.total = item?.total;
      weeks.fri.profit = item?.profit;
      weeks.fri.loss = item?.loss;
    } else if (item.day == "saturday") {
      weeks.sat.total = item?.total;
      weeks.sat.profit = item?.profit;
      weeks.sat.loss = item?.loss;
    } else if (item.day == "sunday") {
      weeks.sun.total = item?.total;
      weeks.sun.profit = item?.profit;
      weeks.sun.loss = item?.loss;
    }
  });

  return { weeklySales: weeks };
};
export const getWeeklyPurchases = async () => {
  let { data } = await DateBookRepository.datebookModel({
    request: {
      method: "getWeeklyPurchases",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  });
  let weeks = {
    mon: { total: 0 },
    tue: { total: 0 },
    wed: { total: 0 },
    thur: { total: 0 },
    fri: { total: 0 },
    sat: { total: 0 },
    sun: { total: 0 },
  };


  let months = {
    jan: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    feb: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    mar: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    apr: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    may: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    jun: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    jul: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    aug: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    sep: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    oct: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    nov: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    dec: {
      total: 0,
      profit: 0,
      loss: 0,
    },
  };
  data.response.data?.dailyPurchases?.forEach((item) => {
    if (item.day == "monday") {
      weeks.mon.total = item?.total;
    } else if (item.day == "tuesday") {
      weeks.tue.total = item?.total;
    } else if (item.day == "wednesday") {
      weeks.wed.total = item?.total;
    } else if (item.day == "thursday") {
      weeks.thur.total = item?.total;
    } else if (item.day == "friday") {
      weeks.fri.total = item?.total;
    } else if (item.day == "saturday") {
      weeks.sat.total = item?.total;
    } else if (item.day == "sunday") {
      weeks.sun.total = item?.total;
    }
  });

  return { weekPurchases: weeks };
};

// export const getProfitLoss = async (start = "", end = "") => {
//   let { data } = await SalesRepository.salesModel({
//     request: {
//       method: "getSalesProfit",
//       data: {
//         company_code: localStorage.getItem("companyCode"),
//         startDate: start,
//         endDate: end,
//       },
//     },
//   });
//   return {
//     totalLoss: data.response.data.sales.loss,
//     totalProfit: data.response.data.sales.profit,
//   };
// };


export const getBanksBalance = async (startDate = "", endDate = "") => {
  try {
    let start = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
    let end = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
    let { data } = await Repo.banks({
      request: {
        method: "getBanksByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start,
          endDate: end,
        },
      },
    });
    let total;
    if (data.response.status.statusCode == 200) {
       total = 0;
      data.response.data.banks.forEach((i) => {
        total += parseInt(i?.balance) || 0;
      });
    }
    const totalBankBalance = total ?? 0
    return { totalBankBalance:totalBankBalance }

  } catch (err) {
    console.log("err:", err);
  }
};

export const getCashInHand = async (startDate = "", endDate = "") => {
  console.log('sss', startDate)
  try {
    let start = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
    let end = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
    let { data } = await Repo.banks({
      request: {
        method: "getCashInHandBankByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start,
        endDate: end,
        },
      },
    });
    console.log(data.response.data.bank,'....')
    // if (data.response.data.bank) {
      const cashInHand = data?.response?.data?.bank?.balance ?? 0;

      return { cashInHand}
    // }
  } catch (err) {
    console.log("err:", err);
  }
};


export const   getPaymentData = async (startDate = "", endDate = "") => {
  console.log('sss', startDate)
  try {
    let start = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
    let end = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
    let { data } = await Repo.payment({
      request: {
        method: "getPaymentsByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start,
        endDate: end,
        },
      },
    });
    console.log(data.response.data.amountTotal,'....')
    // if (data.response.data.bank) {
      const totalPayments = data?.response?.data?.amountTotal ?? 0;

      return { totalPayments}
    // }
  } catch (err) {
    console.log("err:", err);
  }
};


 export const getProfitLoss = async (startDate = "", endDate = "") => {
  let start = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
  let end = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
  // setState((prev) => ({ ...prev, loading: true }));
  const startTime = performance.now();

  let resp = await SalesRepository.salesModel({
    request: {
      method: "getSalesProfitByRange",
      data: {
        company_code: localStorage.getItem("companyCode"),
        startDate: start,
        endDate: end,
      },
    },
  });

  
  const endTime = performance.now(); // Record the end time
  const responseTime = endTime - startTime; // Calculate response time
  console.log("Response Time:", responseTime);

  // Check if response time exceeds 20 seconds
  if (responseTime > 20000) { // 20000 milliseconds = 20 seconds
    await sendEmailNotification("getSalesProfitByRange"); // Trigger email notification
    // toast.success("Email notification sent successfully!");
  }
  console.log(resp.data.response.data.sales.loss)
  console.log(resp.data.response.data.sales.profit)
 const loss = resp.data.response.data.sales.loss ?? 0
 const profit = resp.data.response.data.sales.profit ?? 0
 const totalSales = resp.data.response.data.sales.totalSales ?? 0


  return {
        totalLoss:loss,
        totalProfit:profit,
        totalSales:totalSales,
      };
 
};




export const getOutStock = async (token = "", startDate = "", endDate = "") => {
  try {
    const start = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
    const end = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
    const companyCode = localStorage.getItem("companyCode");
    const startTime = performance.now();

    const dashboardDataResponse = await DefaultRepository.defaultModel({
      request: {
        method: "getDashboardData",
        data: {
          company_code: companyCode,
          startDate,
          endDate,
          next_page_token: token,
        },
      },
    });
    console.log('dashboardDataResponse', dashboardDataResponse);
    const endTime = performance.now(); // Record the end time
    const responseTime = endTime - startTime; // Calculate response time
    console.log("Response Time:", responseTime);
  
    // Check if response time exceeds 20 seconds
    if (responseTime > 20000) { // 20000 milliseconds = 20 seconds
      await sendEmailNotification("getDashboardData"); // Trigger email notification
      // toast.success("Email notification sent successfully!");
    }
    const {
      outOfStockItems,
      next_page_token: dashboardNextPageToken,
      totalSales,
      count,
      soldItems,
      totalStockValue,
      totalStockSaleValue
    } = dashboardDataResponse.data.response.data;


    // const dateBookResponse = await DateBookRepository.datebookModel({
    //   request: {
    //     method: "getBillsRangeDateBookByCompany",
    //     data: {
    //       company_code: companyCode,
    //       startDate,
    //       endDate,
    //       next_page_token: "",
    //       all_reports: start && end ? false : true,
    //     },
    //   },
    // });
    // console.log('dateBookResponse', dateBookResponse);

    // const sales = dateBookResponse.data.response.data.credit;

    // console.log('Sales:', sales);

    return {
      totalSales: totalSales, // Assuming `sales` is the correct value you need
      next_page_token: dashboardNextPageToken,
      totalItems: count,
      soldItems: soldItems,
      totalStock: totalStockValue,
      totalStockSalePrice:totalStockSaleValue,
      outOfStock: outOfStockItems,
    };
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const getRangeSales = async (startDate, endDate) => {
  let { data } = await SalesRepository.salesModel({
    request: {
      method: "getRangeSalesByCompany",
      data: {
        company_code: localStorage.getItem("companyCode"),
        startDate: moment(startDate).format("DD-MM-YYYY"),
        endDate: moment(endDate).format("DD-MM-YYYY"),
        all_reports: false,
      },
    },
  });

  let saleRange = [];

  const start = new Date(startDate);
  const end = new Date(endDate);

  let loop = new Date(start);

  while (loop <= end) {
    let isExists = false;

    data.response.data?.sales?.forEach((item) => {
      if (item?.date === moment(loop).format("DD-MM-YYYY")) {
        isExists = true;
        let isInserted = false;

        saleRange = saleRange.map((obj) => {
          if (obj?.x === item?.date) {
            isInserted = true;

            return {
              x: obj?.x,
              y: obj?.y + item?.totalPrice,
            };
          } else {
            return obj;
          }
        });

        if (!isInserted) {
          saleRange.push({
            x: item?.date,
            y: item?.totalPrice,
          });
        }
      }
    });

    if (!isExists) {
      saleRange.push({
        x: moment(loop).format("DD-MM-YYYY"),
        y: 0,
      });
    }

    const newDate = loop.setDate(loop.getDate() + 1);
    loop = new Date(newDate);
  }
  return { saleRange };
};

export const getYearlySales = async () => {
  let { data } = await SalesRepository.salesModel({
    request: {
      method: "getYearlySales",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  });
  let months = {
    jan: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    feb: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    mar: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    apr: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    may: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    jun: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    jul: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    aug: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    sep: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    oct: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    nov: {
      total: 0,
      profit: 0,
      loss: 0,
    },
    dec: {
      total: 0,
      profit: 0,
      loss: 0,
    },
  };
  data.response.data.yearlySales.forEach((item) => {
    if (item.month == "january") {
      months.jan.total = item?.total;
      months.jan.profit = item?.profit;
      months.jan.loss = Math.abs(item?.loss);
    } else if (item.month == "february") {
      months.feb.total = item?.total;
      months.feb.profit = item?.profit;
      months.feb.loss = Math.abs(item?.loss);
    } else if (item.month == "march") {
      months.mar.total = item?.total;
      months.mar.profit = item?.profit;
      months.mar.loss = Math.abs(item?.loss);
    } else if (item.month == "april") {
      months.apr.total = item?.total;
      months.apr.profit = item?.profit;
      months.apr.loss = Math.abs(item?.loss);
    } else if (item.month == "may") {
      months.may.total = item?.total;
      months.may.profit = item?.profit;
      months.may.loss = Math.abs(item?.loss);
    } else if (item.month == "june") {
      months.jun.total = item?.total;
      months.jun.profit = item?.profit;
      months.jun.loss = Math.abs(item?.loss);
    } else if (item.month == "july") {
      months.jul.total = item?.total;
      months.jul.profit = item?.profit;
      months.jul.loss = Math.abs(item?.loss);
    } else if (item.month == "august") {
      months.aug.total = item?.total;
      months.aug.profit = item?.profit;
      months.aug.loss = Math.abs(item?.loss);
    } else if (item.month == "september") {
      months.sep.total = item?.total;
      months.sep.profit = item?.profit;
      months.sep.loss = Math.abs(item?.loss);
    } else if (item.month == "october") {
      months.oct.total = item?.total;
      months.oct.profit = item?.profit;
      months.oct.loss = Math.abs(item?.loss);
    } else if (item.month == "november") {
      months.nov.total = item?.total;
      months.nov.profit = item?.profit;
      months.nov.loss = Math.abs(item?.loss);
    } else if (item.month == "december") {
      months.dec.total = item?.total;
      months.dec.profit = item?.profit;
      months.dec.loss = Math.abs(item?.loss);
    }
  });

  return { months };
};
export const getYearlyPurchases = async () => {
  let { data } = await DateBookRepository.datebookModel({
    request: {
      method: "getYearlyPurchases",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  });
  let months = {
    jan: {
      total: 0,
    },
    feb: {
      total: 0,
    },
    mar: {
      total: 0,
    },
    apr: {
      total: 0,
    },
    may: {
      total: 0,
    },
    jun: {
      total: 0,
    },
    jul: {
      total: 0,
    },
    aug: {
      total: 0,
    },
    sep: {
      total: 0,
    },
    oct: {
      total: 0,
    },
    nov: {
      total: 0,
    },
    dec: {
      total: 0,
    },
  };
  data.response.data.yearlyPurchases.forEach((item) => {
    if (item.month == "january") {
      months.jan.total = item?.total;
    } else if (item.month == "february") {
      months.feb.total = item?.total;
    } else if (item.month == "march") {
      months.mar.total = item?.total;
    } else if (item.month == "april") {
      months.apr.total = item?.total;
    } else if (item.month == "may") {
      months.may.total = item?.total;
    } else if (item.month == "june") {
      months.jun.total = item?.total;
    } else if (item.month == "july") {
      months.jul.total = item?.total;
    } else if (item.month == "august") {
      months.aug.total = item?.total;
    } else if (item.month == "september") {
      months.sep.total = item?.total;
    } else if (item.month == "october") {
      months.oct.total = item?.total;
    } else if (item.month == "november") {
      months.nov.total = item?.total;
    } else if (item.month == "december") {
      months.dec.total = item?.total;
    }
  });

  return { months };
};
